// import stylesMain from "../../pages/Popup/popupList.module.css";
import styles from "../../Popup/BulkReceipt.module.css"
import FilledButton from "../Buttons/FilledButton";
import ImsgFailure from "../../../public/resources/icon/errorrisk.svg";
import OutlineButton from "../Buttons/OutlineButton";
import React from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import Modal from "react-bootstrap/Modal";

function ErrorApiPopup({ errorAPIMessage = "Please check your connection.", clickErrorButtonHandler, modalIsOpenError, clickOKHandler, buttonName = "" }) {

  return (
    <>
      <Modal show={modalIsOpenError} dialogClassName={styles.modalWidthNew}>
        <Modal.Header>
        </Modal.Header>
        <Modal.Body>
          <div className={`d-flex flex-column ${styles.headError}`}>
            <ImsgFailure className="mx-auto" />
            <p>{process.env.NEXT_PUBLIC_action_failure}!</p>

          </div>
          <div className={styles.contentError}>
            <p className={styles.errorMessagePopup}>{errorAPIMessage}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {buttonName && <OutlineButton
            name={buttonName}
            className="mr-3"
            clickHandler={clickErrorButtonHandler}
          />}
          <FilledButton name="OK" clickHandler={clickOKHandler} />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ErrorApiPopup;
